<template>
    <div class="role_dialog">
        <el-dialog
                :title="title"
                :before-close="cancelButton"
                :visible.sync="dialogVisible"
                max-width="70%"
        >
            <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
            >
                <el-form-item label="EnglishName:" prop="EnglishName">
                    <el-input
                            v-model="ruleForm.englishName"
                            auto-complete="off"
                            placeholder="Please enter Group Name"
                            @blur="groupEngnameBlur"
                            @input="change($event)"
                    ></el-input>
                </el-form-item>
                <el-form-item label="ChineseName:" prop="ChineseName">
                    <el-input
                            v-model="ruleForm.chineseName"
                            auto-complete="off"
                            placeholder="Please enter Group Name"
                            @blur="groupCinnameBlur"
                            @input="change($event)"
                    ></el-input>
                </el-form-item>
                <el-form-item label="GroupDesc:" prop="GroupDesc">
                    <el-input
                            type="textarea"
                            v-model="ruleForm.groupDesc"
                            auto-complete="off"
                            placeholder="Please enter a groupDesc"
                            @input="change($event)"
                    ></el-input>
                </el-form-item>
                <el-form-item label="Group status:" prop="status">
                    <el-radio v-model="ruleForm.status" label="1">On</el-radio>
                    <el-radio v-model="ruleForm.status" label="0">Off</el-radio>
                </el-form-item>
                <el-form-item class="button">
                    <el-button type="primary" @click="submitForm('ruleForm')">Submit</el-button>
                    <el-button @click="resetForm('ruleForm')">Cancel</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {repeatEgropu, repeatCgroup} from "@/common/js/http/version3Api.js";

    export default {
        props: [
            "passVisible",
            "title",
            "editMessage",
            "selectValue",
            "inputValue",
            "editId"
        ],
        name: "GroupDialog",
        data() {
            var groupEnglish = (rule, value, callback) => {
                if (this.ruleForm.englishName === "") {
                    callback(new Error('Group EnglishName cannot be empty'))
                } else {
                    repeatEgropu({id: this.id, name: this.ruleForm.englishName}).then(res => {
                        if (res.result) {
                            callback(new Error("EnglishName already exists, please redefine"));
                        } else {
                            callback();
                        }
                    })
                }
            };
            var groupChinese = (rule, value, callback) => {
                if (this.ruleForm.chineseName === "") {
                    callback(new Error('Group ChineseName cannot be empty'))
                } else {
                    repeatCgroup({id: this.id, name: this.ruleForm.chineseName}).then(res => {

                        if (res.result) {
                            callback(new Error("ChineseName already exists, please redefine"));
                        } else {
                            callback();
                        }
                    })
                }
            };
            return {
                dialogVisible: false,
                id: "",
                repeatEnglish: "",
                repeatChinese: "",
                ruleForm: {
                    englishName: "",
                    chineseName: "",
                    groupDesc: "",
                    status: "1"
                },
                rules: {
                    EnglishName: [{required: true, validator: groupEnglish, trigger: "blur"}],
                    ChineseName: [{required: true, validator: groupChinese, trigger: "blur"}],
                    status: [
                        {required: true, message: "Please Group status", trigger: "change"}
                    ]
                }

            };
        },
        created() {
        },
        methods: {
            //失去焦点
            groupEngnameBlur(val) {
                this.repeatEnglish = this.ruleForm.englishName;
            },
            groupCinnameBlur(val) {
                this.repeatChinese = this.ruleForm.chineseName;
            },
            cancelButton() {
                this.resetForm("ruleForm");
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.$emit('submitForm', this.ruleForm);
                        this.resetForm("ruleForm");
                    } else {

                        return false;
                    }
                });
            },

            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.dialogVisible = false;
                this.$emit("visible", false, this.ruleForm);

            },
            change(e) {
                this.$forceUpdate();
            }
        },
        watch: {
            passVisible(val) {
                this.dialogVisible = val;
            },
            editId() {
                this.id = this.editId;
            },
            editMessage(newValue) {
                this.ruleForm.englishName = newValue.ENName;
                this.ruleForm.chineseName = newValue.ZHName;
                this.ruleForm.groupDesc = newValue.groupDesc;
                if (newValue.status !== '') {
                    this.ruleForm.status = newValue.status + '';
                }
            }

        }
    };
</script>

<style scoped>
    .role_dialog >>> .el-form-item__content .el-input__inner {
        height: 32px;
        line-height: 32px;
    }

    .role_dialog >>> .button .el-form-item__content button {
        height: 32px;
        line-height: 32px;
        padding: 0 20px;
    }

    .role_dialog >>> .el-form-item__content {
        margin-left: 120px !important;
    }

    .role_dialog >>> .el-form-item__label {
        width: 120px !important;
    }

    .role_dialog >>> .button {
        text-align: right;
        margin-bottom: 0;
    }

    .role_dialog >>> .el-dialog__body {
        padding-top: 10px;
    }

    .permission {
        height: 300px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        overflow-y: scroll;
    }
</style>